import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var SchoolSVG = function SchoolSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M30,29a1,1,0,0,1-1,1H5a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h7.47C10.28,18,9,13.45,9,12a4.83,4.83,0,0,1,4.94-5A4.76,4.76,0,0,1,16,7.48V7a2.91,2.91,0,0,1,3-3,1,1,0,0,1,0,2,.92.92,0,0,0-1,1v.48A4.76,4.76,0,0,1,20.06,7,4.83,4.83,0,0,1,25,12c0,1.45-1.28,6-3.47,8H29a1,1,0,0,1,0,2H28v2H6a1,1,0,0,0,0,2H28v2h1A1,1,0,0,1,30,29Z"
  }));
};
SchoolSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SchoolSVG);